// @flow

import { ApolloLink } from 'apollo-link';

import log, { level } from 'app/common/log';

const createLoggingLink = (): ?ApolloLink => {
  if (process.env.NODE_ENV === 'production') {
    return null;
  }

  return new ApolloLink((operation, forward) => {
    return forward(operation).map(data => {
      if (level.verbose) {
        log(`[Apollo]`, operation.operationName, data);
      }
      return data;
    });
  });
};

export default createLoggingLink;
